import {createMultiStyleConfigHelpers} from '@chakra-ui/styled-system';

const helpers = createMultiStyleConfigHelpers(['root', 'video', 'overlay', 'overlayButton']);

/**
 * @typedef {import('@chakra-ui/styled-system').PartsStyleInterpolation<{
 *  keys: ("root" | "video" | "overlay" | "overlayButton")[]
 * }>} VideoStyles
 */
export const videoStyles = helpers.defineMultiStyleConfig({
  defaultProps: {
    variant: 'default',
  },

  variants: {
    /** Non-blog: overlay not rendered (`ContentfulVideoPlayOverlay`); retained for parity. */
    default: {},
    /**
     * Blog article / blog page body: centered play–pause chrome (transparent control, no blurred disc).
     */
    blogArticle: {
      overlay: {
        pointerEvents: 'auto',
      },
      overlayButton: {
        bg: 'transparent',
        backdropFilter: 'none',
        WebkitBackdropFilter: 'none',
        boxShadow: 'none',
        filter: 'drop-shadow(0 2px 10px rgba(0, 0, 0, 0.55))',
        _hover: {
          transform: {base: 'none', lg: 'scale(1.04)'},
          boxShadow: 'none',
        },
      },
    },
  },

  baseStyle: () => ({
    root: {
      position: 'relative',
    },
    /**
     * `.readonly` sets pointer-events:none on amb-video; iframe/video children stay `auto` and steal clicks.
     * Embed surface ignores pointer events — blog layouts use overlay chrome; elsewhere video is decorative.
     */
    video: {
      position: 'relative',
      zIndex: 0,
      sx: {
        '& iframe, & video': {
          pointerEvents: 'none',
        },
      },
    },
    /** Full-area layer; default hit target is only the centered button (`pointerEvents` on overlay itself). */
    overlay: {
      position: 'absolute',
      inset: 0,
      zIndex: 10,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      pointerEvents: 'none',
    },
    overlayButton: {
      pointerEvents: 'auto',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      flexShrink: 0,
      width: {base: '57px', lg: '100px'},
      height: {base: '57px', lg: '100px'},
      borderRadius: 'full',
      border: 'none',
      p: 0,
      cursor: 'pointer',
      color: 'white',
      bg: 'transparent',
      backdropFilter: 'none',
      WebkitBackdropFilter: 'none',
      boxShadow: 'none',
      transitionProperty: 'transform',
      transitionDuration: '0.2s',
      transitionTimingFunction: 'ease',
      _hover: {
        transform: {base: 'none', lg: 'scale(1.04)'},
      },
      _focusVisible: {
        outline: '2px solid',
        outlineColor: 'white',
        outlineOffset: '3px',
      },
      _disabled: {
        opacity: 0.4,
        cursor: 'not-allowed',
        transform: 'none',
        boxShadow: 'none',
      },
    },
  }),
});
